import React from 'react';

const Privacypopup = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow-lg space-y-6 text-sm md:text-base text-gray-700 ">
      <h2 className="text-2xl font-semibold text-[#3D6643]">Privacy Policy </h2>

      <p>
        At Stay Cool, we value your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our vacation rental booking and property management platform.
      </p>

      <h3 className="text-lg font-semibold mt-4">1. Information We Collect</h3>
      <p>
        We collect personal information you provide when registering, booking, listing a property, or contacting support. This includes your name, email address, phone number, billing information, and any property or booking details.
      </p>

      <h3 className="text-lg font-semibold mt-4">2. Usage Data</h3>
      <p>
        We automatically collect technical data such as IP address, browser type, device information, and browsing behavior on our platform for analytics and security purposes.
      </p>

      <h3 className="text-lg font-semibold mt-4">3. How We Use Your Data</h3>
      <ul className="list-disc ml-6">
        <li>To manage bookings and rental listings</li>
        <li>To process payments and send notifications</li>
        <li>To improve user experience and platform features</li>
        <li>To ensure platform security and prevent fraud</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4">4. Sharing of Information</h3>
      <p>
        We do not sell your personal information. We only share data with trusted third-party services such as payment gateways, hosting providers, and analytics tools necessary to operate Stay Cool.
      </p>

      <h3 className="text-lg font-semibold mt-4">5. Data Security</h3>
      <p>
        We implement industry-standard security practices to protect your data from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
      </p>

      <h3 className="text-lg font-semibold mt-4">6. Your Rights</h3>
      <p>
        You have the right to access, correct, or delete your personal information. You may also opt out of non-essential communications at any time.
      </p>

      <h3 className="text-lg font-semibold mt-4">7. Cookies</h3>
      <p>
        We use cookies and similar technologies to improve functionality, personalize content, and analyze site usage. You can manage your cookie preferences in your browser settings.
      </p>

      <h3 className="text-lg font-semibold mt-4">8. Policy Changes</h3>
      <p>
        This Privacy Policy may be updated periodically. We will notify you of significant changes via email or through our platform. Continued use of Stay Cool signifies your acceptance of the revised policy.
      </p>
{/* 
      <h3 className="text-lg font-semibold mt-4">9. Contact Us</h3>
      <p>
        For any privacy-related questions or concerns, contact us at <a href="mailto:privacy@staycool.com" className="text-[#3D6643] underline">privacy@staycool.com</a>.
      </p> */}

      <p className="text-xs text-gray-500">Effective Date: July 26, 2025</p>
    </div>
  );
};

export default Privacypopup;